import { ApiMap } from '../ApiMap';
import { createApiCache } from './createApiCache';
const CtaCache = {};
export function getFetchCtaInfo(http) {
  const withCtaCache = createApiCache(http.get, ApiMap.CTAS.getUrl, CtaCache);
  return function fetchCtaInfo(guid) {
    const httpParams = {
      query: {
        includeCtaInfo: true
      }
    };
    return withCtaCache(guid, httpParams);
  };
}